import type { BaseComponentProps } from "@q4/nimbus-ui";

export interface DownloadCapitalFlowButtonProps extends BaseComponentProps {
  userContext?: Record<string, unknown>;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
}

export enum DownloadCapitalFlowButtonClassName {
  Base = "download-capital-flow-button",
}
